import React from "react";

export const IconForm = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <g id="menu" transform="translate(-6 -1.999)">
                <g
                    id="Path_350"
                    data-name="Path 350"
                    transform="translate(6 2)"
                    fill="rgba(255,255,255,0)"
                >
                    <path
                        d="M 15 15 L 1 15 L 1 1 L 15 1 L 15 15 Z"
                        stroke="none"
                    />
                    <path
                        d="M 2 2 L 2 14 L 14 14 L 14 2 L 2 2 M 0 0 L 16 0 L 16 16 L 0 16 L 0 0 Z"
                        stroke="none"
                        fill="currentColor"
                    />
                </g>
                <line
                    id="Line_51"
                    data-name="Line 51"
                    x2="7.5"
                    transform="translate(10 7)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
                <line
                    id="Line_55"
                    data-name="Line 55"
                    x2="7.5"
                    transform="translate(10 10)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
                <line
                    id="Line_56"
                    data-name="Line 56"
                    x2="2.5"
                    transform="translate(10 13)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
            </g>
        </svg>
    );
};
